import {
    Brick,
    Config,
    Predicate,
    Query,
    registerBrick,
    WorkflowObjectState,
    Transaction,
    ErrorFlow,
} from "olympe";
import BCP from "./DM_BCP.js";
import { BCP_WORKFLOW_STATES } from "./BcpWorkflowAuthorizations";
import { executeLambda } from "../../node/BackendData/LambdaExecutor";
import { getLogger } from "@olympeio/core";
import { getFullURL } from "../../common/BCP_QA_Notification/BCPQAEmailTemplate.js"
import { getFormattedDate, getPersonName, getTargetBCPText, getNotAvailableText } from '../../web/section_sf/Utils.js'
import { uniqueListByProperty, callProxyFunction,sleep } from "../utils/CommonUtil.js"

export default class BPPMEmail extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} sendEmail
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    async update($, [sendEmail], [forwardEvent, setErrorFlow]) {
        const logger = getLogger('BPPMEmail');
        logger.info(`BPPMEmail - Started at ${new Date(Date.now()).toISOString()}`);
        
        try {
            getLogger('BPPMEmail').info(`BPPMEmail - Started BP at ${new Date(Date.now()).toISOString()}`);

            // Get the all BP state request
            let queryBCPBPState = Query.instancesOf(BCP)
                .andReturn()
                .follow(WorkflowObjectState.currentObjectRel.getInverse())
                .filter(
                    Predicate.equals(
                        WorkflowObjectState.stateProp,
                        BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP
                    )
                )
                .andReturn();
            // try {
            const queryBpResult = await queryBCPBPState.execute();
            const bpBCPRequests = queryBpResult.toArray();
            const workflowState = BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP;
            const partnerName = "BP";
            const statement =
                "Please align with business unit & functions on developing a BCP for the material. Once alignment is achieved, please accept/reject the BCP request accordingly.";
            // send BCP request for BP state to generate or send email for BP
            await this.getBCPRequestData(
                bpBCPRequests,
                workflowState,
                partnerName,
                sendEmail,
                $,
                setErrorFlow,
                statement
            );
            getLogger('BPPMEmail').info(`BPPMEmail - Completed BP at ${new Date(Date.now()).toISOString()}`);

            // 10-seconds pause
            await new Promise(resolve => setTimeout(resolve, 10000));

            getLogger('BPPMEmail').info(`BPPMEmail - Started PM at ${new Date(Date.now()).toISOString()}`);

            // Get the all PM state request
            let queryBCPPMState = Query.instancesOf(BCP)
                .andReturn()
                .follow(WorkflowObjectState.currentObjectRel.getInverse())
                .filter(
                    Predicate.equals(
                        WorkflowObjectState.stateProp,
                        BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM
                    )
                )
                .andReturn();

            const queryPMResult = await queryBCPPMState.execute();
            const pmBCPRequests = queryPMResult.toArray();
            const workflowStateBP = BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM;
            const partnerNameBPPM = "PM";
            const statement2 =
                "Please confirm the Vendor site, Main vendor linked and SQA & saving related information to be able to accept the BCP request.";
            // send BCP request for BP state to generate or send email for PM
            await this.getBCPRequestData(
                pmBCPRequests,
                workflowStateBP,
                partnerNameBPPM,
                sendEmail,
                $,
                setErrorFlow,
                statement2
            );
            
            getLogger('BPPMEmail').info(`BPPMEmail - Completed PM at ${new Date(Date.now()).toISOString()}`);
        } 
        catch (error) {
            logger.info("error", error)
            setErrorFlow(
                ErrorFlow.create(`: Could not send email for the error: ${error}`, 400)
            );
        } finally {
            getLogger('BPPMEmail').info(`BPPMEmail - Completed at ${new Date(Date.now()).toISOString()}`); 
            forwardEvent();
        }
    }

    //Generate email template for request and send email
    getObjectEntries = async (
        BCPGroup,
        workflowstate,
        partner,
        sendEmail,
        $,
        setErrorFlow,
        statement
    ) => {
        let ObjectLength = Object.entries(BCPGroup).length
        if (ObjectLength > 0) {
            let indexA = 0;
            for (const [key, value] of Object.entries(BCPGroup)) {
                indexA++;
                //getLogger('BPPMEmail').info("key, value::::::", key, value)
                const emailOfUser = key.split(/[:;]/)[1];
                const nameOfUser = key.split(/[:;]/)[0];
                const blacklist = Config.getParameter("emailBlacklist") || [];
                if (!blacklist.includes(emailOfUser?.toLowerCase())) {
                    //generate the Email template for the particular bcp request
                    let emailBody = await this.generateBPPMEmail(
                        nameOfUser,
                        value,
                        partner,
                        statement,
                        $
                    );
                    const t = new Transaction(true);
                    try {
                        getLogger('BPPMEmail').info(`Before sending BP/PM email to ${emailOfUser}`);
                        let remainder = (indexA + 1) % 100;
                        //getLogger('BPPMEmail').info(":: remainder ::", remainder);
                        getLogger('BPPMEmail').info("BPPMEmail - Email body", emailBody);
                        
                        if (remainder === 0) {
                            await sleep(2000);
                        }
                        
                        await executeLambda($, sendEmail, [emailOfUser, "BCP request - BP/PM notification", emailBody]);
                        value?.forEach((bcp) => {
                            // update the notification state for the bcp request
                            BCP.setNotification_stage(
                                t,
                                bcp.actualBCPObject[0],
                                workflowstate
                            );
                        });
                        await t.execute();

                        getLogger('BPPMEmail').info(`BPPMEmail - Sent email to ${emailOfUser}`); 
                    } 
                    catch (error) {
                        // Handle errors during the send email process
                        getLogger('BPPMEmail').error(`error sending BCP email :${emailOfUser} with reason : ${error.message}`);
                        setErrorFlow(
                            ErrorFlow.create(
                                `error sending BCP email :${emailOfUser} with reason : ${error.message}`,
                                400
                            )
                        );
                    }
                } else {
                    getLogger('BPPMEmail').error(`Email ${emailOfUser} was ignored by the blacklist`);
                    setErrorFlow(
                        ErrorFlow.create(
                            `error sending BCP email :${emailOfUser} with reason : It is blacklisted email id`,
                            400
                        )
                    );
                }
            }
        }
    };

    //grouping the bcp object
    groupBcpByBPPM = (bcp, workflowObject, BCPGroupbyBPPM, bpPmProp) => {
        // Grouping the BP PM Object and send the actual object containing bcp and workflowstate object
        let actualBCPObject = [bcp, workflowObject];
        BCPGroupbyBPPM[bpPmProp].push({
            actualBCPObject,
        });
    };

    // pass the query result data to send the bcp request for email sending for BP and PM
    getBCPRequestData = async (
        bpBCPRequests,
        workflowState,
        partnerName,
        sendEmail,
        $,
        setErrorFlow,
        statement
    ) => {
        let fullName = "";
        const BCPGroupbyBPPM = [];

        if (bpBCPRequests?.length > 0) {
            for (const [bcp, workflowObject] of bpBCPRequests) {
                const bpProp = bcp.get(BCP.businessPartnerProp);
                const pmProp = bcp.get(BCP.procurementManagerProp);
                const notificationStage = bcp.get(BCP.notification_stageProp);

                if (
                    (partnerName === "BP" &&
                        notificationStage !== BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP &&
                        notificationStage !== BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM) ||
                    notificationStage === null ||
                    (partnerName === "PM" &&
                        notificationStage === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP &&
                        notificationStage !== BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM) ||
                    notificationStage === null
                ) {
                    const prop = partnerName === "BP" ? bpProp : pmProp;
                    fullName = prop?.split(/[:;]/)[0];
                    if (!BCPGroupbyBPPM[prop]) {
                        BCPGroupbyBPPM[prop] = [];
                    }
                    // Grouping the bcp object
                    this.groupBcpByBPPM(bcp, workflowObject, BCPGroupbyBPPM, prop);
                }
            }
        }

        // generate the email body and send email for BP state BCP Request
        await this.getObjectEntries(
            BCPGroupbyBPPM,
            workflowState,
            partnerName,
            sendEmail,
            $,
            setErrorFlow,
            statement
        );
    };

    //Template for BP and PM Email generation
    async generateBPPMEmail(username, bcpRequestArray, partnerName, statement, $) {
        const logger = getLogger('BCPQAEmailTemplate')
        /** 
        * @param {string} username
        * @param {!Array<[bcpRequestArray]>}
        * @param {string} partnerName 
        * @return {string}
        */
        const docLink = Config.getParameter('qrcAcceptRejectExplanationLink');
        let emailContent = `
    <p>Dear ${username},</p>
    <p>You have received BCP request(s) that are pending your evaluation. </p>
    <p><b><u>Expected action as a ${partnerName}:</u></b> ${statement}</p>
    <p>To accept/reject a BCP request, please click on this <a href="${getFullURL()}">link</a> to go to the Ensuring Supply WebApp and go to the “Manage BCP Request” tab. To understand how to accept/reject a BCP requests, please click on this <a href="${docLink}">link.</a></p>
    <b>Following BCP request(s) are waiting for your input as a ${partnerName}:</b><br/>
    <table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse;">
      <thead>
        <tr>
          <th style="text-align: left; vertical-align: top; width:90px">Plant</th>
          <th style="text-align: left; vertical-align: top; width:200px">Material</th>
          <th style="text-align: left; vertical-align: top; width:120px">Specification</th>
          <th style="text-align: left; vertical-align: top; width:90px">Main Vendor-Description</th>
          <th style="text-align: left; vertical-align: top; width:90px">Current Vendor site-Description</th>
          <th style="text-align: left; vertical-align: top; width:60px">Requestor</th>
          <th style="text-align: left; vertical-align: top; width:80px">Request date</th>
          <th style="text-align: left; vertical-align: top; width:80px">Main Vendor linked to Alt. Site</th>
          <th style="text-align: left; vertical-align: top; width:80px">Alternative site to be<br/>developed</th>
          <th style="text-align: left; vertical-align: top; width:90px">Target BCP</th>
          <th style="text-align: left; vertical-align: top; width:90px">Priority</th>
          <th style="text-align: left; vertical-align: top; width:60px">Cost Savings</th>
          <th style="text-align: left; vertical-align: top; width:80px">Estimated Savings in CHF</th>
          <th style="text-align: left; vertical-align: top; width:60px">GHG Reduction</th>
          <th style="text-align: left; vertical-align: top; width:240px">Remark</th>
          <th style="text-align: left; vertical-align: top; width:90px">Procurement<br/> Specialist</th>
          <th style="text-align: left; vertical-align: top; width:90px">Business<br/> Partner</th>
          <th style="text-align: left; vertical-align: top; width:90px">Procurement<br/> Manager</th>
          <th style="text-align: left; vertical-align: top; width:90px">CTAG</th>
          <th style="text-align: left; vertical-align: top; width:90px">SQA</th>
          <th style="text-align: left; vertical-align: top; width:90px">QA in the<br/>Factory</th>
        </tr>
      </thead>
      <tbody>`;


        for (let i = 0; i < bcpRequestArray.length; i++) {
            //iterate the all data of bcp object for the particular bcp request or material/plant id
            let data = bcpRequestArray[i].actualBCPObject[0]
            let currentVendorSiteAndDescription
            if (!data.get(BCP.currentVendorSiteIdProp)) {
                currentVendorSiteAndDescription = await this.returnCurrentVendorSite(data, $)
            } else {
                currentVendorSiteAndDescription = data.get(BCP.currentVendorSiteIdProp) + "-" + data.get(BCP.currentVendorSiteDescriptionProp)
            }
            //logger.info("BCPQAEmail:data.get(BCP.currentVendorSiteIdProp)", data.get(BCP.currentVendorSiteIdProp), data.get(BCP.currentVendorSiteIdProp)?.length)
            //logger.info(":::BCPQAEmail: currentVendorSiteAndDescription :::", currentVendorSiteAndDescription)
            emailContent += `
                <tr>
                  <td style="text-align: left; vertical-align:top; width:90px" >${data.get(BCP.plantIdProp) || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top; width:200px" >${(data.get(BCP.materialIdProp) + " - " + (data.get(BCP.materialDescriptionProp) || getNotAvailableText())) || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top; width:120px" >${data.get(BCP.specificationProp) || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top; width:180px" >${data.get(BCP.mainVendorIdProp) ? data.get(BCP.mainVendorIdProp) + ":" + data.get(BCP.mainVendorDescriptionProp) : getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:180px" > ${currentVendorSiteAndDescription}</td>
                  <td style="text-align: left; vertical-align:top;width:60px" >${getPersonName(data.get(BCP.requestorProp))?.fullName || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:80px" >${getFormattedDate(data.get(BCP.requestDateProp))}</td>
                  <td style="text-align: left; vertical-align:top;width:80px" >${data.get(BCP.mainVendorLinkedAltVendorProp) || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:80px" >${data.get(BCP.alternativeVendorCodeProp) || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:90px" >${getTargetBCPText(data.get(BCP.targetBCPProp)) || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:90px" >${data.get(BCP.priorityProp) || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:60px" >${data.get(BCP.costSavingsProp) || "No"}</td>
                  <td style="text-align: left; vertical-align:top;width:90px" >${data.get(BCP.inputSavingEstimatesProp) || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:60px" >${data.get(BCP.ghgReductionProp) || "No"}</td>
                  <td style="text-align: left; vertical-align:top;width:240px" >${data.get(BCP.remarkProp) || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.procurementSpecialistProp))?.fullName || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.businessPartnerProp))?.fullName || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.procurementManagerProp))?.fullName || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.technicalApplicationGroupProp))?.fullName || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.qualityAssuranceProp))?.fullName || getNotAvailableText()}</td>
                  <td style="text-align: left; vertical-align:top;width:90px" >${getPersonName(data.get(BCP.qaInFactoryProp))?.fullName || getNotAvailableText()}</td>
                </tr>`;
        }

        emailContent += `
      </tbody>
    </table>
  
    <p>Please do not reply to this email as this is an automatically generated notification.</p>
    <p>Thank you for your collaboration.</p>
    <p>Your Ensuring Supply Team</p>`;

        return emailContent;
    };
    // This function gets the current vendor site for the mentioned plant and material if the current vendor is not saved in database
    async returnCurrentVendorSite(bcp, $) {
        const logger = getLogger('BPPMEmail')
        const body = { offset: '0', limit: '100', plants: [bcp.get(BCP.plantIdProp)], materials: [bcp.get(BCP.materialIdProp)] };
        // Run fetch
        let concatenatedString = '';
        let response = await callProxyFunction(body, $);
        //.then((response) => {
        // API error
        //logger.info("BPPMEmail: returnCurrentVendorSite Api Response", response)
        if (response.statusCode === 500) {
            logger.error(`API Error: ${response.statusCode} - ${response.message}`);
            return "";
        } else {
            let uniqueVendorList = uniqueListByProperty(response.materials)?.slice(0, 2)
            for (var i = 0; i < uniqueVendorList.length; i++) {
                const item = uniqueVendorList[i];
                concatenatedString += item.vendorSiteNumber + " : " + item.vendorSiteDescription + "\n"
                //logger.info(concatenatedString, "Concatenated vendor site String")
            }
            //logger.info("::Before returning from return CurrentVendor Site::", concatenatedString)           
        }
        return concatenatedString;
    }


}

registerBrick("0194f01f746893fb7c11", BPPMEmail);
